module.exports = __webpack_public_path__ + "static/media/menu-boczne-kwestionariusz_BLUE.1e134821.svg";